<template>
  <div
    v-if="!loading"
    class="list"
  >
    <div v-if="mList && mList.length">
      <load-more
        class="wrapper"
        :data="mList"
        :page="pagination.currentPage"
        :total="pagination.total"
        :limit="pagination.pageSize"
        @loadData="fetchData"
      >
        <template>
          <ul class="content">
            <li
              v-for="(item, index) in mList"
              :key="index"
              :class="{'is-read': !item.isread }"
            >
              <my-item
                :data="item"
                :index="index"
                :status-key="statusKey"
                @handleDetail="handleDetail"
              />
            </li>
          </ul>
          <div class="loading-wrapper" />
        </template>
      </load-more>
    </div>
    <div
      v-else
      class="blank"
    >
      <img
        src="@/assets/images/blank.png"
        :alt="altTip"
      >
      <div class="text">
        {{ $t('message["1553"]') }}
      </div>
    </div>
  </div>
  <cube-loading
    v-else
    :size="24"
  />
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import { getEncode } from '@/lib/mix'
import { setCodeData, base64ToJson } from '@/lib/utils'
import _ from 'lodash'
import LoadMore from '@/components/mobile/LoadMore.vue'
import Item from './Item.vue'
import eventBus from '@/lib/eventBus'

export default {
  components: {
    LoadMore,
    MyItem: Item
  },
  props: {
    from: {
      type: String,
      default: ''
    },
    type: {
      type: [String, Number],
      default: ''
    },
    paramsType: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      pulldown: true
    }
  },
  computed: {
    ...mapState(['menuDatas']),
    ...mapState('inquery/listData', [
      'loading',
      'titles',
      'list',
      'pagination',
      'tableSort'
    ]),
    ...mapState('inquery/filterData', ['filterStr']),
    statusKey () {
      let key = ''
      if (this.from === 'all') {
        switch (this.type) {
          // 负责人
          /* case 'inquiry-manager-all':
          case 'inquiry-manager-followup':
            key = 'base_info_info_status'
            break */
          // 主管、组长
          case 'inquiry-add':
          case 'inquiry-audit':
            key = 'audit_status'
            break
          /* case 'inquiry-followup':
            key = 'base_info_info_status'
            break */
        }
      } else { // my
        switch (this.type) {
          case 'inquiry-add':
          case 'inquiry-audit':
            key = 'audit_status'
            break
          /* case 'inquiry-followup':
            key = 'base_info_info_status'
            break */
        }
      }
      return key
    },
    mList () {
      let data = _.cloneDeep(this.list)
      for (let item of data) {
        for (let fieldkey in item) {
          let column = item[fieldkey]
          // if (_.isPlainObject(column)) {
          //   item.list = item.list || {}
          //   if (fieldkey === 'code' || fieldkey === 'base_info_info_level' || fieldkey === this.statusKey) continue
          //   let obj = item[fieldkey]
          //   obj.fieldkey = fieldkey
          //   for (let k in this.titles) {
          //     if (k === fieldkey) {
          //       obj.title = this.titles[k].fieldname
          //       item.list[fieldkey] = obj
          //       console.log(item.list)
          //     }
          //   }
          // }
          item.list = item.list || {}
          if (fieldkey === 'code' || fieldkey === 'base_info_info_level' || fieldkey === this.statusKey) continue
          let obj = _.isPlainObject(column) ? item[fieldkey] : { fieldvalue: item[fieldkey] }
          obj.fieldkey = fieldkey
          for (let k in this.titles) {
            if (k === fieldkey) {
              obj.title = this.titles[k].fieldname
              item.list[fieldkey] = obj
            }
          }
        }
      }
      return data
    },
    pid () {
      return this.$route.params.pid
    },
    /* filterStr () {
      return this.$route.query.filter
    }, */
    filter () {
      let filters = {}
      if (this.filterStr) {
        filters = base64ToJson(this.filterStr)
        // 将结果放到store
        this.setFilterResult(filters)
      } else {
        this.setFilterResult({})
      }

      return filters
    },
    currentPage () {
      const { page = 1 } = this.$route.query
      return parseInt(page)
    },
    pageSize () {
      const { limit = 10 } = this.$route.query
      return parseInt(limit)
    },
    altTip () {
      return this.$t('message["1553"]')
    }
  },
  watch: {
    type (val) {
      this.pagination.currentPage = 1
      this.pagination.pageSize = 10
      this.setFilterStr('')
      this.setFilterResult({})

      this.SET_TABLE_SORT({ tableSort: {
        sortfieldtype: '',
        sortkey: 'code',
        sorttype: 2
      },
      sorter: {} })
      // this.fetchData()
    },
    $route (to, from) {
      this.pagination.currentPage = this.currentPage
      this.pagination.pageSize = this.pageSize

      if (!this.currentPage || this.currentPage <= 1) {
        this.fetchData()
      }
    }
  },
  created () {
    this.pagination.currentPage = this.currentPage
    this.pagination.pageSize = this.pageSize

    this.fetchData()
    eventBus.$on('fetchInquiryList', this.fetchData)
  },
  methods: {
    ...mapActions('inquery/listData', ['fetchList', 'loadMoreList']),
    ...mapActions('inquery/filterData', ['setFilterResult', 'setFilterStr']),
    ...mapMutations('inquery/listData', ['SET_PAGINATION', 'SET_TABLE_SORT']),
    async fetchData (params = {}) {
      // console.log(params)
      let isFilter = false
      let isPull = false
      let tableSort = this.tableSort

      if (this.filterStr) {
        params.search = await this.setFilterRequestParams(this.filter)
        isFilter = true
      } else {
        isFilter = false
        // this.setFilterResult({})
      }

      tableSort.sortkey && Object.assign(params, { sortkey: tableSort.sortkey })
      tableSort.sorttype && Object.assign(params, { sorttype: tableSort.sorttype })
      tableSort.sortfieldtype && Object.assign(params, { sortfieldtype: tableSort.sortfieldtype })

      this.pagination.currentPage = params.page || this.currentPage
      if ('isPull' in params) {
        isPull = true
      }

      const chain = await this.fetchList({ isFilter, isPull })
      chain
        .params({
          scope: this.from,
          type: this.paramsType,
          page: this.pagination.currentPage,
          limit: this.pagination.pageSize,
          ...params
        })
        .onSuccess(res => {
          const { permissionMenuList = {} } = this.menuDatas
          let parent = {}

          if (!isFilter) {
            this.SET_PAGINATION({
              allCount: res.data && res.data.count
            })
          }

          if (this.from === 'my') {
            parent = permissionMenuList['inquiry-mine'] || {}
          } else if (this.from === 'all') {
            parent = permissionMenuList['inquiry-all'] || {}
          }
          let { child = {} } = parent
          // console.log(this.type, child)
          let { name = '' } = child[this.type] || {}
          document.title = name + '-' + this.$store.state.baseinfo.projectname + '-' + this.$store.state.baseinfo.comname
        })
        .fetch()
    },
    // 点击筛选的确定按钮时，处理数据为 key: value 格式
    async setFilterRequestParams (filter) {
      let obj = {}
      const enCode = await getEncode()
      for (let fieldkey in filter) {
        const item = filter[fieldkey]
        switch (item.fieldtype) {
          case 'text':
          case 'phone':
          case 'email':
          case 'editor':
          case 'tag':
            // console.log('fieldname: ', item.fieldname, item.fieldvalue)
            obj[fieldkey] = await setCodeData(item.fieldvalue, enCode)
            // console.log('value: ', item.fieldvalue)
            break
          case 'area':
            obj[fieldkey] = item.fieldvalue && Object.keys(item.fieldvalue)
            break
          case 'select_tree':
            obj[fieldkey] = item.fieldvalue && Object.keys(item.fieldvalue)
            break
          case 'from_info':
            let arr = []
            let fieldvalue = item.fieldvalue || []
            fieldvalue.forEach((item, index) => {
              let obj = {}
              if (item.length === 1) {
                obj['from_info.from'] = item[0].id
              } else if (item.length === 2) {
                obj[item[1].fieldkey || item[1].id] = item[1].inputVal
              } else if (item.length === 3) {
                obj[item[1].fieldkey || item[1].id] = item[2].id
              }
              arr.push(obj)
            })

            obj['from_info'] = arr
            break
          case 'selectrolegroup':
          case 'selectuser':
            let res = item.fieldvalue || []
            for (let j in res) {
              let one = res[j]
              for (let k in one) {
                if (k === '_id') {
                  delete one[k]
                }
              }
            }
            obj[fieldkey] = res
            break
          case 'selectfollowuser':
          case 'selectinputuser':
            let values = item.fieldvalue || {}
            let users = values[fieldkey] || []
            for (let j in users) {
              let one = users[j]
              for (let k in one) {
                if (k === '_id') {
                  delete one[k]
                }
              }
            }
            obj[fieldkey] = values
            break
          case 'radioinfo_type':
            obj['base_info.info_sign'] = item.info_sign
            obj[fieldkey] = item.fieldvalue
            break
          case 'select_reception':
            let receptionValues = item.fieldvalue || []
            if (this.$toType(receptionValues) !== 'array') return

            obj[fieldkey] = receptionValues.map(value => {
              return value.map(o => o.id)
            })
            break
          default:
            obj[fieldkey] = item.fieldvalue
            break
        }
      }
      return obj
    },

    handleDetail (data) {
      this.$router.push({
        path: `/project/${this.pid}/inquery/detail/${data.inquiryid}`,
        query: {
          ...this.$route.query,
          from: this.from
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  margin-top: 12px;
  // padding: 10px 0 0;
  .cube-scroll-wrapper {
    height: calc(100vh - 46px);
    // height: calc(100vh - 90px);
    overflow: hidden;
  }
  ::v-deep .item {
    margin-top: 0;
  }
  .cube-btn {
    width: 200px;
    margin: 10px auto;
  }
  .content {
    li:last-of-type {
      padding-bottom: 35px;
    }
    li.is-read {
      ::v-deep .sort-rows .one {
        span,
        i {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
